import { CommandType } from "../../../../common/services/cqs/CommandType";
import { Leveransplan } from "../../models/leveransvirkesplan-models";
import { LeveransplanCommandBase } from "./LeveransplanCommandBase";

export class UpdateLeveransplanCommand extends LeveransplanCommandBase {
    readonly id: number;
    kvantitet: number;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "UpdateLeveransplanCommand";

    constructor(leveransplan: Leveransplan) {
        super(leveransplan.virkeskostnadGUID, leveransplan.period, UpdateLeveransplanCommand.$type, CommandType.Replace);
        this.id = leveransplan.id;
        this.kvantitet = leveransplan.kvantitet;
    }
}
